import { createReducer, on } from '@ngrx/store';
import { AppInfo } from 'src/app/models/app-info.model';
import { DrawingMapping, FlatterFilesResponse } from '../../../models';
import { ODataParams, odataParamsFactory, ODataResponse } from '../../../models/odata-response.model';

import * as fromStore from '../..';
import { Loaders } from '.';

export interface State {
  uploadProgress: number;
  appInfo?: AppInfo;
  drawingMappingQuery: ODataParams;
  drawingMappings?: ODataResponse<DrawingMapping[]>;
  flatterFilesExistenceGraph: { [key: string]: FlatterFilesResponse }
  drawingMappingPartNumberFilter?: string;
  drawingMappingFilenameFilter?: string;
  loaders: Loaders[];

  activeTab: number;
}

export const initialState: State = {
  uploadProgress: 0,
  drawingMappingQuery: odataParamsFactory({
    top: 15,
    orderBy: 'partNumber',
    select: ['partNumber', 'filename', 'description', 'isVisible'],
    filter: `description ne 'CIP'`,
    skip: 0,
    count: true
  }),
  flatterFilesExistenceGraph: {},
  loaders: [],
  activeTab: 1
};

export const reducer = createReducer(
  initialState,
  on(fromStore.actions.ADMIN.reportUploadProgress, (state, action) => ({
    ...state,
    uploadProgress: action.progress
  })),
  on(fromStore.actions.ADMIN.loadAppInfo, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingAppInfo)
  })),
  on(fromStore.actions.ADMIN.loadAppInfoSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingAppInfo),
    appInfo: action.info
  })),
  on(fromStore.actions.ADMIN.loadAppInfoFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingAppInfo)
  })),
  on(fromStore.actions.ADMIN.loadDrawingMappings, (state, action) => ({
    ...state,
    drawingMappingQuery: {
      ...state.drawingMappingQuery,
      skip: ((action.page || 1) - 1) * (state.drawingMappingQuery.top)
    },
    loaders: state.loaders.concat(Loaders.loadingDrawingMappings)
  })),
  on(fromStore.actions.ADMIN.loadDrawingMappingsSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDrawingMappings),
    drawingMappings: action.mappings
  })),
  on(fromStore.actions.ADMIN.loadDrawingMappingsFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDrawingMappings)
  })),
  on(fromStore.actions.ADMIN.checkFlatterFilesExistenceSuccess, (state, action) => ({
    ...state,
    flatterFilesExistenceGraph: action.result
  })),
  on(fromStore.actions.ADMIN.changeDrawingMappingsPartNumberFilter, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingDrawingMappings),
    drawingMappingPartNumberFilter: action.val,
    drawingMappingQuery: {
      ...state.drawingMappingQuery,
      skip: 0
    }
  })),
  on(fromStore.actions.ADMIN.changeDrawingMappingsfilenameFilter, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingDrawingMappings),
    drawingMappingFilenameFilter: action.val,
    drawingMappingQuery: {
      ...state.drawingMappingQuery,
      skip: 0
    }
  })),
  on(fromStore.actions.ADMIN.patchDrawingMappingSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingDrawingMappings),
  })),
  on(fromStore.actions.ADMIN.addDrawingMapping, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingDrawingMappings),
  })),
  on(fromStore.actions.ADMIN.addDrawingMappingSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDrawingMappings)
  })),

  on(fromStore.actions.ADMIN.changeActiveTab, (state, action) => ({
    ...state,
    activeTab: action.tab
  }))

);
